import AnalyticsUtil from 'utils/AnalyticsUtil';
export const pushHazardsAnalytics = (action, label = '') => {
    let obj = {
        event: 'track_event',
        category: 'Community Hazards',
        action: action
    };

    if (label) {
        obj['label'] = label;
    }

    AnalyticsUtil.push(obj);
};

export const getSemicircleFromDegrees = (degrees) => {
    // (2^32 / 360) = 11930465
    return (degrees * 11930465) | 0;
};

export const getDegreesFromSemicircle = (semicircle) => {
    // (2^32 / 360) = 11930465
    return semicircle / 11930465;
};
